import { listStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { GridOffset } from "@insite/mobius/GridContainer";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        border: 0;
    `,
};

styles.cardList = {
    ...styles.cardList,
    gridContainer: {
        ...styles.cardList?.gridContainer,
        css: css`
            &[data-test-selector="productListCards_Grid"] [data-test-selector="productList_LearnMore"] {
                margin-top: 5px;
            }

            &[data-test-selector="productListCards_List"] [data-test-selector="productList_LearnMore"] {
                ${mediaQueriesBP.minMD} {
                    margin-inline-start: auto;
                }
            }

            &[data-test-selector="productListCards_List"],
            &[data-test-selector="cardListProductsNarrow"] {
                & > ${GridOffset} {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    margin-bottom: 24px;

                    &[data-test-selector="productListCards_List"] {
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                    }
                }
            }
        `,
    },
};

styles.cardContainerStyles = {
    ...styles.cardContainerStyles,
    cardDivider: {
        css: css`
            border-radius: 4px;
        `,
    },
    gridItem: {},
};
